<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    persistent
    scrollable
  >
    <v-btn v-if="btn" color="primary" block slot="activator" style="width: 100%;">
        <v-icon class="mr-1">mdi-eye</v-icon>
        informações
    </v-btn>
    <v-card>
      <v-card-title class="headline primary white--text justify-center">
        Informações do Usuário
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <!-- Seção de Informações Básicas -->
          <v-layout wrap>
            <v-flex xs12 md4>
              <v-img
                v-if="pessoa.url_imagem_perfil"
                :src="pessoa.url_imagem_perfil"
                aspect-ratio="1"
                class="grey lighten-2"
              ></v-img>
              <v-img
                v-else
                src="https://via.placeholder.com/150"
                aspect-ratio="1"
                class="grey lighten-2"
              ></v-img>
            </v-flex>
            <v-flex xs12 md8>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-sub-title>Nome completo</v-list-tile-sub-title>
                    <v-list-tile-title class="title">{{ pessoa.nome_completo }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-sub-title>CPF</v-list-tile-sub-title>
                    <v-list-tile-title>{{ pessoa.cpf | formatarCPF }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-sub-title>E-mail</v-list-tile-sub-title>
                    <v-list-tile-title>{{ pessoa.email }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-sub-title>Telefone</v-list-tile-sub-title>
                    <v-list-tile-title>{{ pessoa.telefone | formatarTelefone }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-sub-title>Data de Cadastro</v-list-tile-sub-title>
                    <v-list-tile-title>{{ formatarData(pessoa.data_cadastro) }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
          <!-- Seção de Endereço -->
          <v-subheader v-if="pessoa.endereco" class="pl-0">Endereço</v-subheader>
          <v-layout v-if="pessoa.endereco" wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="CEP"
                :value="pessoa.endereco.cep | formatarCEP"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Logradouro"
                :value="pessoa.endereco.logradouro"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Número"
                :value="pessoa.endereco.numero"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8>
              <v-text-field
                label="Complemento"
                :value="pessoa.endereco.complemento || 'Não informado'"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Bairro"
                :value="pessoa.endereco.bairro"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Cidade"
                :value="pessoa.endereco.cidade"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Estado"
                :value="pessoa.endereco.estado"
                readonly
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="País"
                :value="pessoa.endereco.pais"
                readonly
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-alert
            v-else
            :value="true"
            color="info"
            icon="info"
            outline
          >
            Nenhum endereço cadastrado para esta pessoa.
          </v-alert>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="primary" flat @click="fecharDialog">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogVisualizarPessoa',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    btn: {
      type: Boolean,
      default: false
    },
    pessoa: {
      type: Object,
      default: () => ({
        id_pessoa: null,
        ativo: true,
        nome: '',
        sobrenome: '',
        cpf: '',
        data_cadastro: '',
        telefone: '',
        email: '',
        url_imagem_perfil: null,
        endereco: null,
        nome_completo: ''
      })
    }
  },
  data () {
    return {
      dialog: this.value
    }
  },
  watch: {
    value (newVal) {
      this.dialog = newVal
    },
    dialog (newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    fecharDialog () {
      this.dialog = false
      this.$emit('fechar')
    },
    formatarData (data) {
      if (!data) return ''
      const date = new Date(data)
      return date.toLocaleDateString('pt-BR')
    }
  },
  filters: {
    formatarCPF (cpf) {
      if (!cpf) return ''
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    formatarTelefone (telefone) {
      if (!telefone) return ''
      // Formatação simples para telefone
      const nums = telefone.replace(/\D/g, '')
      if (nums.length === 11) {
        return nums.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
      }
      return telefone
    },
    formatarCEP (cep) {
      if (!cep) return ''
      return cep.replace(/(\d{5})(\d{3})/, '$1-$2')
    }
  }
}
</script>

<style scoped>
.v-card__title {
  padding: 16px;
}

.v-card__text {
  padding: 16px;
}

.v-subheader {
  height: 48px;
  margin-top: 16px;
  padding-left: 0;
}
</style>
